var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.headers, function (header) {
        return _c(
          "div",
          { key: header.title },
          [
            _c("v-card-title", [_vm._v(_vm._s(header.title))]),
            _vm._v(" "),
            header.body
              ? _c("v-card-text", { staticClass: "body-1" }, [
                  _vm._v(_vm._s(header.body)),
                ])
              : _vm._e(),
            _vm._v(" "),
            header.comp
              ? _c(
                  header.comp.name,
                  _vm._b(
                    { tag: "component", class: header.comp.classes },
                    "component",
                    { ...header.comp.props },
                    false
                  )
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("v-card-title", [_vm._v("RockStars FAQ:")]),
      _vm._v(" "),
      _c(
        "v-expansion-panels",
        {
          staticClass: "soli-round",
          attrs: { accordion: "" },
          model: {
            value: _vm.panels,
            callback: function ($$v) {
              _vm.panels = $$v
            },
            expression: "panels",
          },
        },
        _vm._l(_vm.FAQS, function (FAQ) {
          return _c(
            "v-expansion-panel",
            { key: FAQ.question },
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "font-weight-bold" },
                [_vm._v(_vm._s(FAQ.question))]
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel-content",
                [
                  FAQ.answer
                    ? _c("div", {
                        staticClass: "body-1",
                        domProps: { innerHTML: _vm._s(FAQ.answer) },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  FAQ.comp
                    ? _c(
                        FAQ.comp.name,
                        _vm._b(
                          { tag: "component", class: FAQ.comp.classes },
                          "component",
                          { ...FAQ.comp.props },
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }